import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { SbAsins } from "@front/m19-api-client";
import { sbAsinsToList } from "@front/m19-models";
import { IHorizontalScrollableAreaComponent } from "@front/m19-ui";
import { AsinItemPreviewComponent } from "@m19-board/strategies/sb-create-strategy/creative-preview-list/asin-item-preview/asin-item-preview.component";

@Component({
  selector: "app-asin-items-preview",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsinItemPreviewComponent, IHorizontalScrollableAreaComponent],
  host: {
    class: "block w-full min-w-0",
  },
  template: `
    <IHorizontalScrollableArea withScrollButton [refreshTrigger]="asins()">
      <div class="flex w-full gap-2.5">
        @for (asin of asinsArray(); track asin) {
          <app-asin-item-preview
            class="w-[calc((100%-1.25rem)/3)] shrink-0"
            [asin]="asin"
            [storePageName]="storePageNames()[$index]"
            [showRating]="showRating()"
          />
        }
      </div>
    </IHorizontalScrollableArea>
  `,
})
export class AsinItemsPreviewComponent {
  readonly asins = input<SbAsins>();
  readonly showRating = input(true);

  readonly asinsArray = computed(() =>
    [this.asins()?.asin1, this.asins()?.asin2, this.asins()?.asin3].concat(
      this.asins() ? sbAsinsToList(this.asins()!).slice(3) : [],
    ),
  );
  readonly storePageNames = computed(() => [this.asins()?.title1, this.asins()?.title2, this.asins()?.title3]);
}
